import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const FreshDeskIframe = observer('FreshDeskIframe', (): JSX.Element | null => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);

    const freshDeskConfig = configComponents.config.freshDeskChat;

    React.useEffect(() => {
        if (freshDeskConfig !== null) {
            setTimeout(() => {
                if (document.getElementById('Freshchat-js-sdk') !== null) {
                    return;
                }

                const chatParams = document.createElement('script');
                chatParams.type = 'text/javascript';
                chatParams.innerHTML = `
                    window.fcSettings = {
                        token: "${freshDeskConfig.token}",
                        host: "${freshDeskConfig.host}",
                        widgetUuid: "${freshDeskConfig.widgetUuid}"
                    };
                `;

                const chatScript = document.createElement('script');
                chatScript.id = 'Freshchat-js-sdk';
                chatScript.type = 'text/javascript';
                chatScript.async = true;
                chatScript.src = `${freshDeskConfig.host}/js/widget.js`;

                document.body.appendChild(chatScript);
                document.body.appendChild(chatParams);

                return () => {
                    const existingScript = document.getElementById('Freshchat-js-sdk');

                    if (existingScript !== null) {
                        document.body.removeChild(existingScript);
                    }
                };
            }, 0);
        }
    }, []);

    return null;
});
